//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'treeComp',
    props: {
        treeData: {
            default: function () {
                return []
            }
        }
    },
    watch: {

    },
    mounted() {
        console.log('this.treeData', this.treeData);
    },
    methods: {
        fn() {
            console.log('this.treeData', this.treeData);

        },
        changeNat(e) {
            console.log(e);
            let key = e.key

            if (key === 'e') {
                e.returnValue = false
                return false
            }
            return true
        },
        ass(e) {
            console.log(e);
            let arr = []
            let arr2 = []
            if (e.length > 6) e = e.slice(0, 8)
            // console.log(this.treeData.price);
            for (let index = 0; index < e.length; index++) {
                console.log(e[index]);
                if (e[index] == '.') {
                    arr.push(e[index])
                }
                arr.push(Number(e[index]))
            }
            for (let index = 0; index < arr.length; index++) {
                console.log(arr[index])
                if (arr[index] == arr[index] || arr[index] == '.') {
                    arr2.push(arr[index])
                }

            }
            console.log(arr);

            console.log(arr2.join(''));
            this.treeData.price = arr2.join('')
        }
    }
}
